import { TemperatureOutputWithStatus } from './temperature-output-with-status.model';


export class TemperatureCalibrationOutputByIdOutput implements ITemperatureCalibrationOutputByIdOutput {
    /** The auto-generated id of the temperature calibration master */
    temperature_calibration_id!: number;
    /** The auto-generated id of the branch details master */
    branch_detail_id!: number;
    /** The auto-generated id of the company details master */
    company_details_id!: number;
    /** The auto-generated id of the vehicle details master */
    vehicle_details_id!: number;
    /** The auto-generated id of the device model port specification master */
    device_model_port_specification_id!: number;
    /**  The multiplication factor */
    multiplication_factor!: number;
    /** The temperature unit */
    temperature_unit!: number;
    /** Manage status of temperature calibration. 0 For De-active, 1 For Active */
    status!: number;
    selected_temperature!: TemperatureOutputWithStatus[];

    constructor(data?: ITemperatureCalibrationOutputByIdOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.temperature_calibration_id = _data["temperature_calibration_id"];
            this.branch_detail_id = _data["branch_detail_id"];
            this.company_details_id = _data["company_details_id"];
            this.vehicle_details_id = _data["vehicle_details_id"];
            this.device_model_port_specification_id = _data["device_model_port_specification_id"];
            this.multiplication_factor = _data["multiplication_factor"];
            this.temperature_unit = _data["temperature_unit"];
            this.status = _data["status"];
            if (Array.isArray(_data["selected_temperature"])) {
                this.selected_temperature = [] as any;
                for (let item of _data["selected_temperature"])
                    this.selected_temperature!.push(TemperatureOutputWithStatus.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TemperatureCalibrationOutputByIdOutput {
        data = typeof data === 'object' ? data : {};
        let result = new TemperatureCalibrationOutputByIdOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["temperature_calibration_id"] = this.temperature_calibration_id;
        data["branch_detail_id"] = this.branch_detail_id;
        data["company_details_id"] = this.company_details_id;
        data["vehicle_details_id"] = this.vehicle_details_id;
        data["device_model_port_specification_id"] = this.device_model_port_specification_id;
        data["multiplication_factor"] = this.multiplication_factor;
        data["temperature_unit"] = this.temperature_unit;
        data["status"] = this.status;
        if (Array.isArray(this.selected_temperature)) {
            data["selected_temperature"] = [];
            for (let item of this.selected_temperature)
                data["selected_temperature"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ITemperatureCalibrationOutputByIdOutput {
    /** The auto-generated id of the temperature calibration master */
    temperature_calibration_id: number;
    /** The auto-generated id of the branch details master */
    branch_detail_id: number;
    /** The auto-generated id of the company details master */
    company_details_id: number;
    /** The auto-generated id of the vehicle details master */
    vehicle_details_id: number;
    /** The auto-generated id of the device model port specification master */
    device_model_port_specification_id: number;
    /**  The multiplication factor */
    multiplication_factor: number;
    /** The temperature unit */
    temperature_unit: number;
    /** Manage status of temperature calibration. 0 For De-active, 1 For Active */
    status: number;
    selected_temperature: TemperatureOutputWithStatus[];
}

